import { CommonModule } from '@angular/common';
import {
    Component,
    OnInit,
    ViewChild,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import {
    MatAutocompleteModule,
    MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { MatInput, MatInputModule } from '@angular/material/input';
import { Observable, debounceTime, startWith, switchMap } from 'rxjs';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'zop-icon-picker',
    imports: [
        CommonModule,
        FormlyModule,
        ReactiveFormsModule,
        FormsModule,
        MatAutocompleteModule,
        MatInputModule,
        MatIconModule
    ],
    template: `
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>
                {{ to.label }}
                <span *ngIf="to.required" class="mat-form-field-required-marker"> *</span>
            </mat-label>
            <input
                matInput
                [matAutocomplete]="auto"
                [formControl]="formControl"
                [formlyAttributes]="field"
                [errorStateMatcher]="errorStateMatcher"
            />
            <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="displayFn.bind(this)"
                (optionSelected)="onSelectionChange($event)"
            >
                @for (option of items | async; track option) {
                    <mat-option [value]="option.value">
                        {{ option.label }}
                        <mat-icon [svgIcon]="'heroicons_solid:' + option.icon"></mat-icon>
                    </mat-option>
                }
            </mat-autocomplete>

            <mat-error *ngIf="showError">
                <formly-validation-message [field]="field"></formly-validation-message>
            </mat-error>
        </mat-form-field>
    `,
    styles: [
        `
            .full-width {
                width: 100%;
            }
            mat-form-field {
                display: flex;
                flex-direction: column;
            }
        `,
    ]
})
export class ZopIconPicker
    extends FieldType<FieldTypeConfig>
    implements OnInit
{
    @ViewChild(MatInput) formFieldControl!: MatInput;
    @ViewChild(MatAutocompleteTrigger) autocomplete!: MatAutocompleteTrigger;
    items?: Observable<
        {
            label: string;
            value: string;
            icon: string;
        }[]
    >;
    errorStateMatcher!: ErrorStateMatcher;
    iconSelected: any;

    ngOnInit() {
        // <mat-option *ngFor="let item of items | async" [value]="item">
        //             {{ item.label }}
        //             <mat-icon [svgIcon]="'heroicons_solid:' + item.icon"></mat-icon>
        //         </mat-option>
        this.items = this.formControl.valueChanges.pipe(
            startWith(this.formControl.value || ''),
            debounceTime(200),
            switchMap((term) => {
                return this.props['filter'](term) as Observable<
                    {
                        label: string;
                        value: string;
                        icon: string;
                    }[]
                >;
            })
        );
    }

    displayFn(item: any): string {
        return item;
    }

    onSelectionChange(event: any) {
        const selectedValue = event.option.value;
        this.formControl.setValue(selectedValue);
        this.iconSelected = selectedValue;
    }
}